"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphicWrapper = void 0;
var React = require("react");
var GraphicWrapper = function (_a) {
    var children = _a.children, _b = _a.Height, Height = _b === void 0 ? "96px" : _b, _c = _a.Width, Width = _c === void 0 ? "96px" : _c;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: Width, height: Height, viewBox: "0 0 96 96" }, children));
};
exports.GraphicWrapper = GraphicWrapper;
